export default "__VITE_ASSET__DUXLhqTC__"